import { user } from './user';
import { logger } from './logger';
import { publicAPI } from './publicAPI';

export const middleware = [
    user,
    logger,
    publicAPI
];
